<!-- eslint-disable no-console -->
<script setup>
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import DssGlobalLoading from '@/core/components/dss-global-loading/dss-global-loading.vue'
import EnvIndicator from '@/core/components/env-indicator/env-indicator.vue'
import { useLayout } from '@/core/composables/layout.composable'
import { syncAmplitudeEngagementLocale } from '@/core/config/amplitude-engagement.util'
import authLayout from '@/core/layouts/auth.layout.vue'
import errorLayout from '@/core/layouts/error.layout.vue'
import homeLayout from '@/core/layouts/home.layout.vue'
import newAuthLayout from '@/core/layouts/new-auth.layout.vue'
import publicLayout from '@/core/layouts/public.layout.vue'
import shellLayout from '@/core/layouts/shell.layout.vue'
import wizardLayout from '@/core/layouts/wizard.layout.vue'
import { useAuthStore } from '@/modules/auth/stores/auth.store'
import { useAnalytics } from '@/shared/analytics'

const layouts = {
  auth: authLayout,
  newAuth: newAuthLayout,
  shell: shellLayout,
  home: homeLayout,
  error: errorLayout,
  wizard: wizardLayout,
  public: publicLayout,
}

const { currentLayout, isInitialized } = useLayout(layouts)
const authStore = useAuthStore()
const route = useRoute()
const {
  identifyUser,
  loadContext,
  resetUser,
  isEnabled: isAnalyticsEnabled,
} = useAnalytics()

const { locale } = useI18n()

watch(locale, (newLocale) => {
  if (window.$primevue && window.$primevue.changeLocale) {
    window.$primevue.changeLocale(newLocale)
  }

  syncAmplitudeEngagementLocale(newLocale)
}, { immediate: true })

watch(
  () => route.path.split('/').find(Boolean) || null,
  () => {
    loadContext()
  },
  { immediate: true },
)

watch(
  () => [
    authStore.isAuthenticated,
    authStore.userData?.b2cId,
  ],
  ([isAuthenticated, userB2cId]) => {
    if (!isAnalyticsEnabled.value)
      return

    if (!isAuthenticated) {
      resetUser()
      return
    }

    if (userB2cId)
      identifyUser()
  },
  { immediate: true },
)
</script>

<template>
  <component
    :is="currentLayout"
    v-if="isInitialized"
  >
    <router-view />
  </component>
  <dss-toast />
  <dss-global-loading />
  <env-indicator />
</template>
